module.exports = __webpack_public_path__ + "static/media/no_skrivhastighet_video.38437e4e.mov";